export default __webpack_public_path__ + "static/media/team.17e4c920.svg";